import useAppLanguage from 'hooks/useAppLanguage';
import { Tooltip } from 'react-tooltip';
import { useGetProfileQuery } from 'store/slices/profile-api';
import appHelpers, { getMarketingUrl } from 'utils/app-urls';
import copyToClipboard from 'utils/copy-to-clipboard';
import messages from '../../messages';
import RewardsShareCard from './RewardsShareCard';

const cdnURL = appHelpers.getCDNUrl();

export default function RewardsShare() {
  const language = useAppLanguage();
  const { data: profile } = useGetProfileQuery();

  const shareModalMessages = messages[language].shareModal;
  const shareLinksMessages = messages[language].shareLinks;

  const url = profile?.referralCode
    ? `${import.meta.env.VITE_BASE_URL}/auth/signup?promoCode=${profile.referralCode}`
    : '';

  const whatsApp = shareLinksMessages.whatsAppMessage(
    url,
    `${profile?.baseCurrency?.symbol}${profile?.refereeRewardAmountAsFunctional}`,
    `${profile?.baseCurrency?.symbol}${profile?.refereeMinBuyAmountAsFunctional}`,
  );
  const twitter = shareLinksMessages.twitterMessage(
    url,
    `${profile?.baseCurrency?.symbol}${profile?.refereeRewardAmountAsFunctional}`,
  );
  const facebook = shareLinksMessages.facebookMessage(
    url,
    `${profile?.baseCurrency?.symbol}${profile?.refereeRewardAmountAsFunctional}`,
    `${profile?.baseCurrency?.symbol}${profile?.refereeMinBuyAmountAsFunctional}`,
  );
  const email = shareLinksMessages.emailMessage(
    encodeURIComponent(url),
    `${profile?.baseCurrency?.symbol}${profile?.refereeRewardAmountAsFunctional}`,
    `${profile?.baseCurrency?.symbol}${profile?.refereeMinBuyAmountAsFunctional}`,
  );

  function handleCopyLink() {
    copyToClipboard(url);
  }

  return (
    <div>
      <h3 className="sm:mb-10 sm:mt-0 mb-3">{shareModalMessages.heading}</h3>
      <div
        className="text text-center max-w-sm m-auto mb-4"
        dangerouslySetInnerHTML={{
          __html: shareModalMessages.content(
            'Altify',
            getMarketingUrl(),
            profile?.baseCurrency?.symbol ?? '',
            profile?.rewardPointFunctionalRate ?? 0,
            profile?.refereeRewardAmountAsFunctional ?? 0,
            profile?.refereeMinBuyAmountAsFunctional ?? 0,
            profile?.referrerRewardsPoints ?? 0,
          ),
        }}
      />
      <div className="sm:px-3 flex-row flex items-center justify-center sm:justify-between mb-6 sm:mb-2">
        <RewardsShareCard
          image="assets/share/whatsapp.svg"
          imageAltText={shareModalMessages.altTextWhatsapp}
          text={shareModalMessages.headerWhatsapp}
          link={`https://api.whatsapp.com/send?phone=&text=${whatsApp}`}
        />
        <RewardsShareCard
          image="assets/share/Facebook.svg"
          imageAltText={shareModalMessages.altTextFacebook}
          text={shareModalMessages.headerFacebook}
          link={`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${facebook}`}
        />
        <RewardsShareCard
          image="assets/share/x.svg"
          imageAltText={shareModalMessages.altTextTwitter}
          text={shareModalMessages.headerTwitter}
          link={`http://x.com/intent/post?text=${twitter}`}
        />
        <RewardsShareCard
          image="assets/share/Email.svg"
          imageAltText={shareModalMessages.altTextEmail}
          text={shareModalMessages.headerEmail}
          link={`mailto:?body=${email}`}
        />
      </div>
      <div className="relative rounded-card border mt-2 duration-1000 gradient-promo">
        <div className="flex flex-row z-10 relative rounded-card px-4 py-1 bg-background duration-1000">
          <div className="flex-grow my-1 text-white truncate">
            {url?.replace(/(^\w+:|^)\/\//, '')}
          </div>
          <div className="flex-shrink mx-1">
            <button
              type="button"
              className="bg-background p-1.5 py-1 px-0 rounded-full copy text-sm text-header-text"
              onClick={() => handleCopyLink()}
              data-tooltip-content={shareModalMessages.copied}
              data-tooltip-id="copy-tooltip">
              <img
                src={`${cdnURL}assets/share/copy.svg`}
                alt=""
                className="center"
              />
            </button>
            <Tooltip
              id="copy-tooltip"
              openEvents={{ click: true }}
              place="bottom"
              className="w-max-content"
              aria-haspopup="true"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
